import React from 'react';

/*eslint-disable */

var arrowLeft = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    width: "8px",
    height: "12px",
    viewBox: "0 0 8 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1049.000000, -403.000000)",
    fill: "#C2C3C9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1049.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99018758,1.65685425 L9.65685425,1.65685425 L9.65685425,9.65685425 L6.99018758,9.65685425 L6.99018758,4.32352092 L1.65685425,4.32352092 L1.65685425,1.65685425 L6.99018758,1.65685425 Z",
    transform: "translate(5.656854, 5.656854) rotate(-135.000000) translate(-5.656854, -5.656854) "
  }))))));
});

export default arrowLeft;
